/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HospitalizationDto } from '../../models/hospitalization-dto';

export interface HospitalizationCheckExistingPreHospi$Params {

/**
 * filter criteria
 */
  siteId?: number;
}

export function hospitalizationCheckExistingPreHospi(http: HttpClient, rootUrl: string, params?: HospitalizationCheckExistingPreHospi$Params, context?: HttpContext): Observable<StrictHttpResponse<HospitalizationDto>> {
  const rb = new RequestBuilder(rootUrl, hospitalizationCheckExistingPreHospi.PATH, 'get');
  if (params) {
    rb.query('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HospitalizationDto>;
    })
  );
}

hospitalizationCheckExistingPreHospi.PATH = '/v1/Hospitalization/CheckExistingPreHospi';
